export default function FormsComponent() {
    // List of forms
    const forms = [
      { name: "Work From Home Form", file: "/images/wfh.docx" },
      { name: "Uber Check List Form", file: "/images/uc.docx" },
      { name: "Information Check List Form", file: "/images/infocheck.pdf" },
    ];
  
    return (
      <div>
        {/* Hero Section */}
        <section
          className="relative text-center w-full h-[600px]"
          style={{
            backgroundImage: "url('/images/bg3.jpeg')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50 text-white p-6">
            <h1 className="text-4xl font-bold mb-4 md:text-6xl">Forms</h1>
            <p className="text-lg max-w-3xl text-gray-300 md:text-2xl">
            Fill out essential forms and gain insights into tax regulations. Manage your finances efficiently with proper documentation and informed tax planning for a secure financial future!
            </p>
          </div>
        </section>
  
        {/* Forms Download Section */}
        <div className=" flex flex-col items-center justify-center bg-slate-900 p-6">
          <h2 className="text-3xl font-bold mb-6 text-white">Download Forms</h2>
  
          <div className="w-full max-w-lg bg-white p-6 rounded-lg shadow-md border">
            {forms.map((form, index) => (
              <div key={index} className="flex flex-col md:flex-row text-center justify-between items-center p-4 border-b last:border-b-0">
                <span className="text-lg font-medium text-gray-700">{form.name}</span>
                <a 
                  href={form.file} 
                  download 
                  className="bg-blue-500 text-white px-4 py-2 rounded mt-3 md:mt-0 hover:bg-blue-700 transition"
                >
                  Download
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
  